import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { TranscricaoAnexo } from '../../transcricaoTypes';
import { formatTamanhoArquivo, getExtensaoArquivo } from '../../transcricaoAnexoUtils';
import { sxAnexosCardExcluirButton } from './sxTranscricaoAnexos';

interface TranscricaoAnexosCardListProps {
  anexos: TranscricaoAnexo[];
  onExcluir: (index: number) => void;
}

const TranscricaoAnexosCardList: React.FC<TranscricaoAnexosCardListProps> = ({ anexos, onExcluir }) => {
  const accessibility = useAccessibility();

  return (
    <ul className="transcricao-anexos-cards">
      {anexos.map((anexo, index) => (
        <li
          key={`${anexo.nomeArquivo}-${index}`}
          className="transcricao-anexo-card"
          style={{
            ...accessibility.contrastStyle,
            ...accessibility.contrastBorderAccessibility,
          }}
        >
          <div className="transcricao-anexo-card-grid">
            <div className="transcricao-anexo-card-field">
              <span className="transcricao-anexo-card-label" style={accessibility.textStyleAccessibility}>
                Documento
              </span>
              <span className="transcricao-anexo-card-value" style={accessibility.textStyleAccessibility}>
                {anexo.nomeArquivo}
              </span>
            </div>
            <div className="transcricao-anexo-card-field">
              <span className="transcricao-anexo-card-label" style={accessibility.textStyleAccessibility}>
                Tipo
              </span>
              <span className="transcricao-anexo-card-value" style={accessibility.textStyleAccessibility}>
                {getExtensaoArquivo(anexo.nomeArquivo)}
              </span>
            </div>
            <div className="transcricao-anexo-card-field transcricao-anexo-card-field--full">
              <span className="transcricao-anexo-card-label" style={accessibility.textStyleAccessibility}>
                Tamanho
              </span>
              <span className="transcricao-anexo-card-value" style={accessibility.textStyleAccessibility}>
                {formatTamanhoArquivo(anexo.tamanhoBytes)}
              </span>
            </div>
          </div>

          <hr className="transcricao-anexo-card-divider" aria-hidden="true" />

          <Button
            type="button"
            variant="outlined"
            className="transcricao-anexo-card-excluir"
            sx={sxAnexosCardExcluirButton}
            style={accessibility.buttonStyleAccessibility}
            onClick={() => onExcluir(index)}
            aria-label={`Excluir arquivo ${anexo.nomeArquivo}`}
            endIcon={
              <FontAwesomeIcon
                icon={faTrashCan}
                style={accessibility.buttonTextStyleAccessibility}
              />
            }
          >
            <b style={accessibility.buttonTextStyleAccessibility} aria-hidden="true">
              EXCLUIR ARQUIVO
            </b>
          </Button>
        </li>
      ))}
    </ul>
  );
};

export default TranscricaoAnexosCardList;
